function calculatePriceAfterDiscount(price, discount, discountType) {
  if (discountType === 'percent') {
    return price * (1 - discount / 100);
  } else if (discountType === 'fixed') {
    return price - discount;
  }
  return price;
}

export { calculatePriceAfterDiscount };
